var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParentPageSect2Icon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 6,
    fill: "#22C55E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_868_22602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 41.6289H25C24.2044 41.6289 23.4413 41.3128 22.8787 40.7502C22.3161 40.1876 22 39.4246 22 38.6289V30.6289C22 30.3637 21.8946 30.1093 21.7071 29.9218C21.5196 29.7343 21.2652 29.6289 21 29.6289C20.7348 29.6289 20.4804 29.7343 20.2929 29.9218C20.1054 30.1093 20 30.3637 20 30.6289V38.6289C20 39.955 20.5268 41.2268 21.4645 42.1644C22.4021 43.1021 23.6739 43.6289 25 43.6289H37C37.2652 43.6289 37.5196 43.5236 37.7071 43.336C37.8946 43.1485 38 42.8941 38 42.6289C38 42.3637 37.8946 42.1093 37.7071 41.9218C37.5196 41.7343 37.2652 41.6289 37 41.6289ZM41 23.6289H27C26.2044 23.6289 25.4413 23.945 24.8787 24.5076C24.3161 25.0702 24 25.8333 24 26.6289V36.6289C24 37.4246 24.3161 38.1876 24.8787 38.7502C25.4413 39.3128 26.2044 39.6289 27 39.6289H41C41.7956 39.6289 42.5587 39.3128 43.1213 38.7502C43.6839 38.1876 44 37.4246 44 36.6289V26.6289C44 25.8333 43.6839 25.0702 43.1213 24.5076C42.5587 23.945 41.7956 23.6289 41 23.6289ZM40.59 25.6289L34.71 31.5089C34.617 31.6026 34.5064 31.677 34.3846 31.7278C34.2627 31.7786 34.132 31.8047 34 31.8047C33.868 31.8047 33.7373 31.7786 33.6154 31.7278C33.4936 31.677 33.383 31.6026 33.29 31.5089L27.41 25.6289H40.59ZM42 36.6289C42 36.8941 41.8946 37.1485 41.7071 37.336C41.5196 37.5235 41.2652 37.6289 41 37.6289H27C26.7348 37.6289 26.4804 37.5235 26.2929 37.336C26.1054 37.1485 26 36.8941 26 36.6289V26.9989L31.88 32.8789C32.4425 33.4407 33.205 33.7563 34 33.7563C34.795 33.7563 35.5575 33.4407 36.12 32.8789L42 26.9989V36.6289Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_868_22602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentPageSect2Icon1);
export default __webpack_public_path__ + "static/media/parentPage-sect2-icon1.3df13979b7f5d72fbb0e769ad4daa978.svg";
export { ForwardRef as ReactComponent };